import { FormattedMessage, useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    Adg4BannerAlert,
    BannerProps
} from "@/patterns/adg4/banner-alert/banner-alert";

export const HomePageBannerAlert = () => {
    const intl = useIntl();

    const rovoBannerData: BannerProps = {
        identifier: "HomePageTemplateV2.banner-alert.rovo",
        text: (
            <FormattedMessage
                id="HomePageTemplateV2.banner-alert.rovo.text"
                defaultMessage="<strong>Unlock enterprise knowledge with Generative AI.</strong>"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "HomePageTemplateV2.banner-alert.rovo.linkText",
            defaultMessage: "Meet Rovo"
        }),
        linkUrl: "https://www.atlassian.com/software/rovo",
        productKey: "home",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "HomePageTemplateV2.banner-alert.rovo.dataLabel",
                defaultMessage: "Meet Rovo"
            }),
            "data-label-english": "Meet Rovo"
        }
    };

    if (FeatureGates.checkGate("wac-homepage-alert-banner-rovo")) {
        return (
            <UFOSegment name="homepage-v2-bannerAlert">
                <Adg4BannerAlert {...rovoBannerData} />
            </UFOSegment>
        );
    }

    return null;
};
